import axios from "axios";
import BaseController from "./BaseController";
import InvalidEmailError from "../modules/error/InvalidEmailError";
import TooManyRequestsError from "../modules/error/TooManyRequestsError";
import WeakPasswordError from "../modules/error/WeakPasswordError";
import WrongPasswordError from "../modules/error/WrongPasswordError";

export interface UserMe {
  userId: string;
  email: string;
  role: string;
  allowedModeIds: string[];
  allowedLicenseIds: string[];
  allowedLocales: string[];
  allowedPresets: string[];
}

export default class StudioAuthController extends BaseController {
  constructor(hostUrl: string, apiKey: string) {
    super(hostUrl, apiKey);
  }

  /**
   * 이메일로 로그인
   * @param email 이메일
   * @param password 비밀번호
   * @throws {WrongPasswordError} 잘못된 패스워드
   * @throws {TooManyRequestsError} 지나치게 많은 요청
   */
  public async loginWithEmailAsync(email: string, password: string): Promise<void> {
    try {
      await axios.post(
        `${this.hostUrl}/api/v1/auth/signin`,
        { email, password },
        {
          headers: {
            "Content-Type": "application/json",
            "x-functions-key": this.apiKey,
          },
          withCredentials: true,
        }
      );
    } catch (error: any) {
      this.throwErrorFromStatus(error.response?.status);
    }
  }

  /**
   * 유저 정보 조회
   */
  public async getMeAsync(): Promise<UserMe> {
    try {
      const response = await axios.get<UserMe>(
        `${this.hostUrl}/api/v1/users/me`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-functions-key": this.apiKey,
          },
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error: any) {
      this.throwErrorFromStatus(error.response?.status);
    }
  }

  // 로그아웃
  public async logoutAsync(): Promise<void> {
    try {
      await axios.post(
        `${this.hostUrl}/api/v1/auth/signout`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "x-functions-key": this.apiKey,
          },
          withCredentials: true,
        }
      );
    } catch (error: any) {
      this.throwErrorFromStatus(error.response?.status);
    }
  }
  
  private throwErrorFromStatus(status: number): never {
    if (status === 401) throw new WrongPasswordError("잘못된 패스워드");
    if (status === 422) throw new WeakPasswordError("약한 암호");
    if (status === 429) throw new TooManyRequestsError("지나치게 많은 요청");
    if (status === 400) throw new InvalidEmailError("잘못된 이메일");
    throw new Error(`예상치 못한 오류: ${status}`);
  }
}